import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';

import { mediaQueries } from '@general/breakpoints';
import useClickOutside from '@hooks/useClickOutside';

const DropdownMenuStyled = styled.div`
    left: unset;
    right: unset;
`;
const DropdownButton = styled.button`
    background: none;
    border: none;
    border-bottom: 6px solid #e11837;
    color: #fff;
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    outline: none;
    padding-bottom: 4px;
    padding-left: 0;
    padding-right: 0;

    @media ${mediaQueries.lg} {
        padding-left: 4px;
    }

    &:focus {
        outline: none;
    }

    &::after {
        background: url('/assets/images/down-arrow-white.svg') no-repeat !important;
    }
`;

// What makes this a Hero specific dropdown?
const HeroDropdown = ({ options = [], selectedOption = null, onOptionSelect }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const clickOutsideRef = useRef(null);

    useClickOutside({ ref: clickOutsideRef, onClickOutside: () => setDropdownOpen(false) });

    const rappaClasses = classnames('dropdown-rappa', { show: dropdownOpen }, 'd-flex', 'justify-content-center');
    const selection = selectedOption || options[0];

    return (
        <div className="dropdown d-flex justify-content-center mb-3">
            <div className={rappaClasses} ref={clickOutsideRef}>
                <DropdownButton
                    id="dropdownMenuLink"
                    type="button"
                    href="#"
                    className="display4 heroCat ml-auto"
                    aria-haspopup="true"
                    aria-expanded={dropdownOpen}
                    onClick={event => {
                        event.preventDefault();
                        setDropdownOpen(!dropdownOpen);
                    }}
                >
                    {selection.selectedLabel}
                </DropdownButton>

                <DropdownMenuStyled
                    className="dropdown-menu m-0 mt-2 px-2"
                    id="dropdownMenu"
                    aria-labelledby="dropdownMenuLink"
                >
                    {options.map(option => {
                        const optionClasses = classnames('dropdown-item my-3', { accent: option.id === selection.id });

                        const optionStyles = {
                            ...styles.dropdownOption,
                            display: option.hidden ? 'none' : 'inherit',
                        };

                        return (
                            <button
                                key={option.id}
                                type="button"
                                className={optionClasses}
                                style={optionStyles}
                                onClick={() => {
                                    setDropdownOpen(false);
                                    onOptionSelect(option);
                                }}
                            >
                                <div>{option.optionLabel}</div>
                            </button>
                        );
                    })}
                </DropdownMenuStyled>
            </div>
        </div>
    );
};

const styles = {
    dropdownOption: {
        border: 'none',
        fontFamily: 'Red Hat Display',
        outline: 'none',
    },
};

HeroDropdown.propTypes = {
    options: PropTypes.array,
    selectedOption: PropTypes.object,
    onOptionSelect: PropTypes.func,
};

export default HeroDropdown;
